import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-capital-back',
  imports: [],
  templateUrl: './capital-back.html',
  styleUrl: './capital-back.scss',
})
export class CapitalBack {
  constructor(private location: Location) { }

  back() {
    this.location.back();
  }
}
